// What a family attribute's source is: the product type attribute it inherits, or the value list a
// family-specific attribute was seeded from.
export enum FamilyAttributeSourceLevel {
  COMPANY = 'company',
  PRODUCT_TYPE = 'product_type',
}
